import { render } from "./market.vue?vue&type=template&id=7dbb548d&scoped=true"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"

import "./market.vue?vue&type=style&index=0&id=7dbb548d&lang=scss"
import "./market.vue?vue&type=style&index=1&id=7dbb548d&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbb548d"]])

export default __exports__